import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Input, Button } from 'antd';

export default function WhyChooseUs({ cellValue, onFocusOut }) {
  // Sanitise the cellValue to ensure it is an array of objects with 'heading' and 'explanation' only
  const sanitisedValue = Array.isArray(cellValue)
    ? cellValue.filter(
        (item) => item && typeof item === 'object' && 'heading' in item && 'explanation' in item
      )
    : [{ heading: '', explanation: '' }]; // Default if cellValue is not an array

  const [renderedValue, setRenderedValue] = useState(sanitisedValue);

  const handleInputChange = (event, index) => {
    const { name, value } = event.target;
    const updatedValue = [...renderedValue];
    updatedValue[index] = { ...updatedValue[index], [name]: value };

    setRenderedValue(updatedValue);
  };

  // Ensure that the onFocusOut callback is triggered only after making changes
  const handleFocusOut = () => {
    onFocusOut({ target: { name: 'why_choose_us', value: renderedValue } });
  };

  const handleAddItem = () => {
    const newItem = { heading: '', explanation: '' };
    const updatedValue = [...renderedValue, newItem];
    setRenderedValue(updatedValue);
  };

  return (
    <div>
      {renderedValue.map((item, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={index} style={{ borderBottom: 'solid 1px lightGray', marginBottom: '12px' }}>
          <label>
            Heading:
            <Input
              placeholder="type here"
              type="text"
              name="heading"
              value={item.heading}
              onBlur={handleFocusOut}
              onChange={(event) => handleInputChange(event, index)}
            />
          </label>
          <br />
          <label>
            Explanation:
            <Input
              placeholder="type here"
              type="text"
              name="explanation"
              value={item.explanation}
              onBlur={handleFocusOut}
              onChange={(event) => handleInputChange(event, index)}
            />
          </label>
        </div>
      ))}
      <Button type="primary" onClick={handleAddItem}>
        Add Item
      </Button>
    </div>
  );
}

WhyChooseUs.propTypes = {
  cellValue: PropTypes.object,
  onFocusOut: PropTypes.func,
};

WhyChooseUs.defaultProps = {
  cellValue: {},
  onFocusOut: () => {},
};
